import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useSetting } from '../../context/SettingContext';
import { FaHistory } from 'react-icons/fa';
import { FaBell, FaBookMedical, FaChevronDown, FaCircleUser, FaClipboardList, FaClipboardQuestion, FaGear, FaHouseChimney, FaUser, FaUserDoctor, FaUserSecret } from 'react-icons/fa6';

const Sidebar = ({ t }) => {
    const location = useLocation();
    const { auth } = useAuth();
    const { setting } = useSetting();
    const [isUserManagementDropdownOpen, setUserManagementOpen] = useState(false);
    
    useEffect(() => {
        const adminRoutes = ['/user-role', '/user'];
        
        if (adminRoutes.includes(location.pathname)) {
            setUserManagementOpen(true);
        } else {
            setUserManagementOpen(false);
        };
    }, [location.pathname]);
    
    const adminItems = [
        { to: '/user-role', icon: <FaUserSecret />, label: t('menu.userRole') },
        { to: '/user', icon: <FaUserDoctor />, label: t('menu.user') }
    ];
    
    const navItems = [
        { to: '/dashboard', icon: <FaHouseChimney />, label: t('menu.dashboard') },
        { to: '/sufferer', icon: <FaUser />, label: t('menu.sufferer') },
        { to: '/panic-log', icon: <FaBell />, label: t('menu.panicLog') },
        { to: '/therapy-material', icon: <FaBookMedical />, label: t('menu.therapyMaterial') },
        { to: '/screening-question', icon: <FaClipboardQuestion />, label: t('menu.screeningQuestion') },
        { to: '/screening-log', icon: <FaClipboardList />, label: t('menu.screeningLog') },
        { to: '/history', icon: <FaHistory />, label: t('menu.history'), adminOnly: true },
        { to: '/logo-title-setting', icon: <FaGear />, label: t('menu.setting'), adminOnly: true }
    ];
    
    return (
        <div className='flex flex-col h-screen w-64 bg-antiFlashWhite lg:border-r-2 lg:border-platinum text-sm text-blackOlive font-medium overflow-y-auto'>
            <div className='p-5 space-y-5'>
                <div className='flex justify-center'>
                    <img
                        className='h-10 leading-10 object-cover'
                        src={setting.logo_url}
                        alt='Logo'
                    />
                </div>
                <div className='flex px-5 py-2.5 w-full text-center items-center justify-center rounded bg-platinum'>
                    <span>{setting[`title_${t('languages.select')}`]}</span>
                </div>
            </div>
            <nav className='flex-grow'>
                {/* User Management */}
                {auth?.role.name.toLowerCase().includes('admin') && (
                    <div>
                        <button
                            className={`
                                flex w-full p-5 items-center justify-between cursor-pointer hover:bg-gradient-to-r hover:from-primary hover:via-primary hover:to-secondary hover:text-white focus:bg-gradient-to-r focus:outline-none focus:from-primary focus:to-primary focus:text-white 
                                ${isUserManagementDropdownOpen ? 'bg-gradient-to-r from-primary to-secondary text-white' : ''}
                            `}
                            onClick={() => setUserManagementOpen(!isUserManagementDropdownOpen)}
                        >
                            <div className='flex items-center space-x-2'>
                                <FaCircleUser className='h-5 w-5' />
                                <span>{t('menu.userManagement')}</span>
                            </div>
                            <FaChevronDown className={`text-xs transition-transform duration-300 ${isUserManagementDropdownOpen ? 'transform rotate-180' : ''}`} />
                        </button>
                        {isUserManagementDropdownOpen && (
                            <div>
                                {adminItems.map(({ to, icon, label }) => (
                                    <NavLink
                                        key={to}
                                        className={({ isActive }) => `flex pl-12 pr-5 py-5 items-center hover:bg-gradient-to-r hover:from-primary hover:via-primary hover:to-secondary hover:text-white focus:bg-gradient-to-r focus:outline-none focus:from-primary focus:to-primary focus:text-white transition duration-300 ${isActive ? 'bg-gradient-to-r from-primary to-secondary text-white' : ''}`}
                                        to={to}
                                    >
                                        <div className='flex items-center space-x-2'>
                                            <span className='text-xl'>{icon}</span>
                                            <span>{label}</span>
                                        </div>
                                    </NavLink>
                                ))}
                            </div>
                        )}
                    </div>
                )}
                
                {/* Main Nav Links */}
                {navItems.map(({ to, icon, label, adminOnly }) => (
                    (!adminOnly || (adminOnly && auth?.role.name.toLowerCase().includes('admin'))) && (
                        <NavLink
                            key={to}
                            className={({ isActive }) => `flex p-5 items-center hover:bg-gradient-to-r hover:from-primary hover:via-primary hover:to-secondary hover:text-white focus:bg-gradient-to-r focus:outline-none focus:from-primary focus:to-primary focus:text-white transition duration-300 ${isActive ? 'bg-gradient-to-r from-primary to-secondary text-white' : ''}`}
                            to={to}
                        >
                            <div className='flex items-center space-x-2'>
                                <span className='text-xl'>{icon}</span>
                                <span>{label}</span>
                            </div>
                        </NavLink>
                    )
                ))}
            </nav>
        </div>
    );
};

export default Sidebar;
